import { useQueryClient as useRQueryClient } from "react-query";

import type { UseQueryClientReturnType } from "./types";

export const useQueryClient = (): UseQueryClientReturnType => {
  return useRQueryClient();
};
